/**
 * @file index.tsx
 *
 * @fileoverview Renders the default icon for when an organization has no logo.
 */

import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { Box } from '~/vcl/atoms/07-box';
import { StackImageIcon } from '~/vcl/icons/StackImage';

interface OrganizationDetailNoLogoSlotProps {
  /**
   * The organization to render the icon for.
   */
  organization: Slottable<OrganizationProfile>;
}

export default function OrganizationDetailNoLogoSlot({
  organization,
}: OrganizationDetailNoLogoSlotProps) {
  return (
    <Box
      marginTop={0}
      boxShadow="none"
      padding={3}
      borderColor="gray2"
      borderWidth="1px"
    >
      <StackImageIcon
        color="gray3"
        height="100px"
        width="100px"
        title="Logo placeholder"
      />
    </Box>
  );
}
export { OrganizationDetailNoLogoSlot };
